<template>
  <section class="sidebar-layout">
    <b-sidebar
      class="secondary-sidebar"
      mobile="fullwidth"
      position="static"
      type="is-light"
      :open="shouldSidebarBeOpen">
      <div class="p-1">
        <div class="block">
          <b-menu class="is-custom-mobile">
            <b-menu-list>
              <b-menu-item
                v-for="(option, i) in options"
                :id="`${option.id}-tab`"
                :key="`${option}-${i}`"
                :label="option.label"
                :icon="option.icon"
                :value="option.label"
                :active="sectionActive == i && screenWidth >= 768 && openSidebar"
                @click="handleClick(i)">
                <div v-if="option.submenu && option.submenu.length > 0">
                  <b-menu-item
                    v-for="(subOption, j) in option.submenu"
                    :id="`${subOption.id}-sub-tab`"
                    :key="`${subOption}-${j}`"
                    :label="subOption.title"
                    :disabled="j>0"
                    :active="j===0"
                    :value="subOption.title" />
                </div>
              </b-menu-item>
            </b-menu-list>
          </b-menu>
        </div>
      </div>
    </b-sidebar>
  </section>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
      default: () => { return []; }
    },
    openSidebar: {
      type: Boolean
    },
    sectionActive: {
      type: Number
    }
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      submenuActive: false
    };
  },
  computed: {
    shouldSidebarBeOpen() {
      // If the screen width is less than or equal to 910px (an example threshold for mobile screens),
      // use the openMenu prop to control the sidebar's openness.
      if (this.screenWidth <= 768) {
        return this.openSidebar;
      }
      // On desktop screens, the sidebar should always be open.
      return true;
    }
  },
  async mounted() {
    // Add an event listener to watch for window resize events
    window.addEventListener('resize', this.updateScreenWidth);
  },
  beforeDestroy() {
    // Remove the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateScreenWidth);
  },

  methods: {
    updateScreenWidth() {
      // Update the screenWidth property when the window is resized
      this.screenWidth = window.innerWidth;
    },
    handleClick(i) {
      this.$emit('sectionActive', i);
      if (window.innerWidth <= 768) {
        // Set openMenu to false to close the sidebar on mobile
        this.openSidebarEmit();
      }
    },
    openSidebarEmit() {
      if (!this.openSidebar) {
        this.$emit('openSidebar', true);
        return;
      }
      this.$emit('openSidebar', false);
    }
  }
};
</script>

<style>
.secondary-sidebar .sidebar-content {
  background-color: transparent !important;
  border: none;
  max-width: 250px;
}

@media screen and (max-width: 768px) {
  .sidebar-layout {
    position: relative;
}
.secondary-sidebar a.is-active {
  background-color: transparent;
  color: hsl(0, 0%, 29%) ;
}
.secondary-sidebar .menu-list a:hover {
  background-color: hsl(0, 0%, 96%);
}
}
</style>
